import QuickIcon01 from "./images/main/quick_icon01.png";
import QuickIcon02 from "./images/main/quick_icon02.png";
import QuickIcon03 from "./images/main/quick_icon03.png";
import QuickIcon04 from "./images/main/quick_icon04.png";
import QuickIcon05 from "./images/main/quick_icon05.png";
import QuickIcon06 from "./images/main/quick_icon06.png";

export const Quick = [QuickIcon01, QuickIcon02, QuickIcon03, QuickIcon04, QuickIcon05, QuickIcon06];

export const getSrc = (set) => {
    let image = "";
    for (let i in set) {
        const img = set[i];
        const num = parseInt(i);
        if (num !== 0) {
            image += ", ";
        }
        image += `${img} ${num + 1}x`;
    }
    return image;
};

export const getBackground = (set) => {
    let image = "";
    for (let i in set) {
        const img = set[i];
        const num = parseInt(i);
        if (num !== 0) {
            image += ", ";
        }
        image += `url(${img}) ${num + 1}x`;
    }
    return image;
};
